<img [src]="data" (click)="closePhotoModal()">